export const refs = {
    form: document.querySelector('#task-form'),
    taskList: document.querySelector('#task-list'),
    buttonChangeTheme: document.querySelector('#themeToggle'),
    body: document.querySelector('body'),
}















